import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=b2943a4e"
var script = {}
import style0 from "./Why.vue?vue&type=style&index=0&id=b2943a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports